(function () {
    /* Colour swatch hover -> image swap, self-contained (no dependency on
       the theme's <product-card> custom element / Core module loader). */
    function bindSwatches() {
        document.querySelectorAll('.js-piana-swatch-wrap').forEach(function (wrap) {
            if (wrap.dataset.pianaBound) return;
            wrap.dataset.pianaBound = 'true';
            var swatches = wrap.querySelector('[data-element="swatches"]');
            if (!swatches) return;
            swatches.addEventListener('mouseover', function (e) {
                var dot = e.target.closest('[data-swatch-number]');
                if (dot) {
                    wrap.setAttribute('data-selected-swatch', dot.getAttribute('data-swatch-number'));
                }
            });
            swatches.addEventListener('mouseout', function (e) {
                if (!e.relatedTarget || !swatches.contains(e.relatedTarget)) {
                    wrap.removeAttribute('data-selected-swatch');
                }
            });
            swatches.addEventListener('focusin', function (e) {
                var dot = e.target.closest('[data-swatch-number]');
                if (dot) {
                    wrap.setAttribute('data-selected-swatch', dot.getAttribute('data-swatch-number'));
                }
            });
            swatches.addEventListener('focusout', function () {
                wrap.removeAttribute('data-selected-swatch');
            });
        });
    }

    /* Title sizing is handled entirely in CSS now (line-clamp + reserved
       min-height), so there's no post-paint font-shrink pass here any
       more - that JS pass was a real CLS contributor, shifting the price/
       includes/button stack every time it ran on load. See the -title
       rule in the section's {% style %} block. */

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindSwatches);
    } else {
        bindSwatches();
    }
})();
